import { getErrorStatus, getErrorText } from '../../../../../common/api/errors'

const PREVIEW_LABELS = { COMMISSION_NO_DEFAULT_RULE: 'Нет правила по умолчанию' }

/** What the commission preview shows for a failed calculation (`getErrorText` with the preview's own labels). */
export function previewErrorText(e: unknown): string {
  const status = getErrorStatus(e)
  const fallback = status !== undefined && status >= 500 ? 'Не удалось рассчитать комиссию' : 'Ошибка запроса'

  return getErrorText(e, fallback, { labels: PREVIEW_LABELS, withFieldName: false })
}
